// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPin = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M14.107 2.75l-1.415 1.414.707.707-6.363 4.95L5.62 8.407 4.207 9.82l4.243 4.243-4.95 4.95v1.414h1.414l4.95-4.95 4.243 4.243 1.414-1.415-1.414-1.414 4.95-6.364.707.707 1.414-1.414zm3.535 6.364l-2.828-2.828-.088.088-6.265 4.872 4.22 4.22 4.873-6.264z"
    />
  );
export default SvgIconPin;
